import { Column } from 'src/shared/components/Semantic/all'
import { QuoteListRow } from 'src/api/db/apiQuote'
import { paths } from 'src/routes/paths'
import { RequestCard } from './RequestCard'

export const RequestsList = ({
  quotes,
  listSearch = '',
  detailPath = paths.requests,
  basePath = paths.myAccount,
  showOrg,
}: {
  quotes: QuoteListRow[]
  listSearch?: string
  detailPath?: string
  basePath?: string
  showOrg?: boolean
}) => {
  return (
    <Column className="mt-6 shrink-0">
      <div className="grid grid-cols-3 gap-4">
        {quotes.map((quote, index) => (
          <RequestCard
            key={String(quote.public_id ?? quote.id ?? index)}
            quote={quote}
            listSearch={listSearch}
            detailPath={detailPath}
            basePath={basePath}
            showOrg={showOrg}
          />
        ))}
      </div>
    </Column>
  )
}

/** @deprecated Use RequestsList */
export const OrdersList = RequestsList
